/* eslint-disable camelcase */
import React, { PureComponent, Component } from 'react';
import PropTypes from 'prop-types';
import {
    View,
    Text,
    TextInput,
    FlatList,
    ScrollView,
    Animated
} from 'react-native';
import {
    JDTouchable,
    JDImage,
    JDText
} from '@jdreact/jdreact-core-lib';
import { utils } from '@ltfe/ltfe-core-lib';
import { tip, is_android, mta, mtaPV } from '../../common/utils';
import st from './st_city';
import mock from './mock';

const city_list = mock.retObj.city;
const hot_city = mock.retObj.hotCity;
const { pt } = utils;

export default class CityList extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            ac_letter: '',
            show_search: false,
            search_list: null,
            searchValue: null,
            // 当前选择城市[]
            cur_city: {}
        };
        this.render_item = this.render_item.bind(this);
        this.change_letter = this.change_letter.bind(this);
        this.change_city = this.change_city.bind(this);
        this.filter = this.filter.bind(this);
        this.set_height = this.set_height.bind(this);
    };

    static defaultProps = {
        city_list: city_list,
        title: '区域选择',
        hot_city: hot_city,
        lbs: null,
        // 当前选择城市[]
        cur_city: { cityId: 11, cityName: '上海', cityPy: 'bj', fullPy: 'beijing' }
    }

    render() {
        const { ac_letter, show_search, search_list, searchValue } = this.state;

        const { city_list, title } = this.props;

        return (
            <View style={ [st.container, { flex: 1 }] }>

                <SearchInput
                    show_search={ show_search }
                    show_list={ () => this.setState({ show_search: true }) }
                    hide_list={ () => {
                        const { searchValue } = this.state;

                        mta('CitySearchCancel', searchValue, 'City', searchValue);
                        this.setState({ show_search: false, search_list: null });
                    } }
                    on_change={ (text) => this.filter(text) }
                    on_clear={ () => this.setState({ search_list: null, searchValue: null }) }
                />
                <View style={ { flex: 1, backgroundColor: '#F1F3F5' } }>
                    {!show_search && city_list
                        ? <FlatList
                            ref='scroll'
                            data={ city_list[ac_letter] }
                            renderItem={ this.render_item }
                            initialNumToRender={ 20 }
                            keyExtractor={ (item, index) => index }
                            ListHeaderComponent={ this.render_header.bind(this) }
                            ListFooterComponent={ <View style={ { height: pt(is_android ? 200 : 230) + (global.is_x ? 76 : 0) } } /> }
                        />
                        : null
                    }

                    {/* {global.is_x&&<View style={{height:76}}/>} */}

                    {show_search ? (<Search_list searchValue={ searchValue } list={ search_list } change_city={ this.change_city } />) : null}
                </View>
            </View>
        );
    }

    componentDidMount() {
        const { cur_city } = this.props;

        document.title = this.props.title;

        this.setState({
            cur_city: cur_city,
            ac_letter: 'a'
        });

        mtaPV('City');
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.ac_letter != prevState.ac_letter) {
            if (this.state.ac_letter !== 'a') {
                setTimeout(() => {
                    this.refs.scroll.scrollToOffset({
                        offset: this.state.ac_letter ? this.wrap - this.letter : 0,
                        animated: false
                    });
                }, 100);
            }
        };
    }

    filter(text) {
        this.setState({ searchValue: text });

        let search_list = [];

        const all_cn_reg = /^[\u4e00-\u9fa5]+$/;

        const all_en_reg = /^[a-z]+$/i;

        text = text.replace(/ /g, '');

        if (!text) {
            this.setState({ search_list: null });

            return;
        };

        if (all_cn_reg.test(text)) {
            search_list = this.filter_text(text, 'cityName', 0);
        };

        if (all_en_reg.test(text)) {
            const txt_len = text.length;

            let len, fir_item, thr_item;

            fir_item = 'cityPy';
            thr_item = 'fullCityPy';

            search_list = this.filter_text(text, fir_item, 0);
            len = search_list.length;
            // if(len<10){
            search_list = search_list.concat(this.filter_text(text, thr_item, len));
            // };
        };
        // search_list= hot_city
        this.setState({ search_list });
    }

    filter_text(text, key, init_num) {
        if (!text) return;
        const { city_list } = this.props;

        const temp_list = [];

        const keys = Object.keys(city_list);

        keys.forEach((value) => {
            // if(init_num>9) return false;
            loop(city_list[value]);
        });

        function loop(data) {
            data && data.forEach((val) => {
                // if(init_num>9 || !val[key] || val[key]==undefined) return false;
                if (!val[key] || val[key] == undefined) return false;

                const item = val[key].match(new RegExp(`${key == 'cityName' ? '' : '^'}${text}`, 'i'));

                if (item) {
                    temp_list.push(Object.assign(val, { match: item[0] }));
                    init_num++;
                };
            });
        };

        return temp_list;
    }

    render_header() {
        return (
            <ListHeader
                { ...this.props }
                { ...this.state }
                change_letter={ this.change_letter }
                change_city={ this.change_city }
                set_height={ this.set_height }
            />
        );
    }

    render_item(item) {
        const { cur_city } = this.state;

        return (
            <ListItem
                data={ item }
                change_city={ this.change_city }
                cur_city={ cur_city }
            />
        );
    }

    change_letter(ac_letter) {
        if (this.state.ac_letter == ac_letter) { return; };
        this.setState({ ac_letter: ac_letter });
    }

    change_city(data, type) {
        const { searchValue } = this.state;

        if (type == 'search') {
            mta('CityAssociation', 'City', searchValue + '_' + data.cityName);
        } else if (type == 'letter') {
            mta('CityList', 'City', data.cityName);
        } if (type == 'hot') {
            mta('CityHot', 'City', data.cityName);
        }

        storage.load({
            key: 'movieCityHistory'
        }).then((res) => {
            if (res) {
                res.forEach((val, key) => {
                    if (val.cityName == data.cityName) {
                        res.splice(key, 1);
                    };
                });
                res.unshift(data);
                storage.save({
                    key: 'movieCityHistory',
                    data: res.splice(0, 8)
                });
            } else {
                storage.save({
                    key: 'movieCityHistory',
                    data: [data]
                });
            }
        }).catch((err) => {

        });
        this.props.reCity(data);
        this.context.router.pop();
    }

    set_height(item, height) {
        this[item] = height;
    }
}

class Search_list extends PureComponent {
    constructor(props) {
        super(props);
    };

    render() {
        const { list, change_city, searchValue } = this.props;

        return (
            <ScrollView style={ st.search_list } keyboardDismissMode='on-drag' >
                {list && (list.length ? list.map((val, index) => {
                    if (val.cityName.indexOf(searchValue) >= 0) {
                        // 有关键字搜索标红
                        const splitvalue = val.cityName?.split(searchValue);

                        return (
                            <JDTouchable key={ index } contentContainerStyle={ st.search_item } onPress={ () => change_city(val, 'search') }>
                                <Text numberOfLines={ 2 } style={ st.city_text }>

                                    {
                                        splitvalue.map((val, index) => {
                                            return (
                                                (index + 1 == splitvalue.length)
                                                    ? <JDText key={ index }>{splitvalue[index]}</JDText>
                                                    : <JDText key={ index }>
                                                        {splitvalue[index]}
                                                        <JDText style={ st.searchValue }>{searchValue}</JDText>
                                                    </JDText>
                                            );
                                        })
                                    }
                                </Text>
                            </JDTouchable>
                        );
                    } else {
                        return (
                            <JDTouchable key={ index } contentContainerStyle={ st.search_item } onPress={ () => change_city(val, 'search') }>
                                <View>
                                    <JDText style={ st.city_text }>{val.cityName}</JDText>
                                </View>
                            </JDTouchable>
                        );
                    }
                })
                    : <View style={ st.search_item }>
                        <JDText style={ st.city_text }>抱歉，没有搜索到相关结果</JDText>
                    </View>)}
                <View style={ st.bottom_view } />
            </ScrollView>
        );
    }
}

class SearchInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            width: new Animated.Value(pt(this.props.show_search ? 50 : 0)),
            show_clear: false
        };
        this.change = this.change.bind(this);
        this.clear = this.clear.bind(this);
        this.hide = this.hide.bind(this);
    };

    render() {
        const { show_list, show_search } = this.props;
        const { width } = this.state;

        return (
            <View style={ st.top_search }>
                <View style={ st.wrap_input }>
                    <TextInput
                        placeholder='请输入城市'
                        style={ st.search_input }
                        underlineColorAndroid='transparent'
                        ref={ (ele) => { this.search_input = ele; } }
                        onFocus={ show_list }
                        onChangeText={ this.change }
                    // onFocus={()=>mta('CityInput','City')}
                    />
                    {/* {(show_search&&show_clear)&&
                        <JDTouchable style={st.search_clear} onPress={this.clear}>
                            <JDImage source={img.search_clear}/>
                        </JDTouchable>} */}

                </View>
                <JDImage source={ img.search_img } style={ st.search_img } />

                <Animated.View style={ [st.ani_cancel, { width }] }>
                    <JDTouchable contentContainerStyle={ [st.search_cancel] } onPress={ this.hide }>
                        {show_search && <JDText numberOfLines={ 1 }>取消</JDText>}
                    </JDTouchable>
                </Animated.View>
            </View>
        );
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.show_search != nextProps.show_search) {
            Animated.timing(this.state.width, {
                toValue: pt(nextProps.show_search ? 50 : 0),
                duration: 500
            }).start();
        };
    }

    change(text) {
        this.props.on_change(text);
        this.setState({
            show_clear: !!text
        });
    }

    clear() {
        this.setState({
            show_clear: false
        });
        this.props.on_clear();
        const input = this.search_input.refs.input;

        input.blur();
    }

    hide() {
        this.setState({
            show_clear: false
        });
        this.props.hide_list();
        const input = this.search_input.refs.input;

        input.blur();
        this.props.on_clear();
        input.value = '';
    }
}

class ListHeader extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            isClick: false
        };

        this.render_item = this.render_item.bind(this);
        this.getLbsFn = this.getLbsFn.bind(this);
    };

    render() {
        const { ac_letter, change_letter, city_list, set_height, hot_city, lbs } = this.props;
        const { isClick } = this.state;

        Object.keys(city_list).forEach((val) => {
            if (!city_list[val]) {
                delete city_list[val];
            }
        });

        return (
            <View onLayout={ (e) => set_height('wrap', e.nativeEvent.layout.height) }>

                {lbs
                    ? <View style={ st.header_section }>
                        {this.renderTitle('当前城市')}
                        <View style={ st.hd_wrap_city }>
                            {this.render_item(lbs, 0, false, true)}
                        </View>
                    </View>
                    : <View style={ st.header_section }>
                        {this.renderTitle('当前城市')}
                        <JDTouchable onPress={ this.getLbsFn }>
                            {/* <JDTouchable> */}
                            <View style={ st.lbs_city }>
                                <JDImage style={ st.lbs } source={ img.lbs_gray } />
                                <JDText style={ st.lbs_txt }>{isClick ? '定位中...' : '定位失败，点击重新获取位置'}</JDText>
                            </View>
                        </JDTouchable>
                    </View>}

                {
                    <View style={ st.header_section }>
                        {this.renderTitle('热门城市')}
                        <View style={ st.hd_wrap_city }>
                            {hot_city.map((v, k) => this.render_item(v, k + 1, false, false, true))}
                        </View>
                    </View>
                }

                <View style={ st.header_section } onLayout={ (e) => set_height('letter', e.nativeEvent.layout.height) }>

                    {this.renderTitle('更多城市')}
                    <View style={ st.hd_wrap_city }>
                        {
                            Object.keys(city_list).sort().map((val, key) => {
                                const ac = ac_letter == val;

                                key = key + 1;

                                const no_margin = (!(key % 6) && key) ? { marginRight: 0 } : null;

                                const text = val.toUpperCase();

                                return (
                                    <JDTouchable
                                        key={ key }
                                        onPress={ () => change_letter(val) }
                                    >
                                        <View style={ [st.hd_city_view, st.hd_letter_view, ac && st.ac_item, no_margin] }>
                                            <JDText style={ [st.hd_city_item, ac && st.ac_text] }>{text}</JDText>
                                        </View>
                                    </JDTouchable>
                                );
                            })
                        }
                    </View>

                </View>

            </View>
        );
    }

    componentDidMount() {

    }

    getLbsFn() {
        this.setState({
            isClick: true
        });
        this.props.getLbs();
    }

    renderTitle(title) {
        return (
            <View style={ st.hd_title }>
                <View><JDText style={ st.hd_tit_txt }>{title}</JDText></View>
            </View>
        );
    }

    render_item(data, key, is_history, is_lbs, is_hot) {
        const { change_city, cur_city } = this.props;

        const ac = (data && data.cityName == cur_city.cityName);

        const no_margin = (!(key % 4) && key) ? { marginRight: 0 } : null;

        return (
            <JDTouchable style={ [st.hd_city_view, (ac && !is_history) && st.ac_item, no_margin] } key={ key } contentContainerStyle={ st.hd_city_view_con } onPress={ () => change_city(data, is_hot ? 'hot' : '') }>

                {is_lbs && <JDImage source={ (ac && !is_history) ? img.lbs : img.lbs_gray } style={ st.lbs } />}
                <JDText style={ [st.hd_city_item, (ac && !is_history) && st.ac_text, is_lbs && st.max] } numberOfLines={ 1 }>
                    {data.cityName}
                </JDText>
            </JDTouchable>

        );
    }
}

class ListItem extends PureComponent {
    render() {
        const { data, cur_city } = this.props;

        const active = cur_city && (data && data.item && data.item.cityName == cur_city.cityName);

        return (
            <View style={ [st.list_item, active && st.ac_item] }>
                <JDTouchable onPress={ () => this.props.change_city(data.item, 'letter') }>
                    {/* <View style={[st.list_hotel]}> */}
                    {active && <JDImage source={ img.right_img } style={ st.list_item_text_sec_active } />}
                    <JDText style={ [st.list_item_text, active && { color: '#E2231A' }] }>{data.item.cityName} </JDText>
                    {/* {data.item.nation&&<JDText style={[st.list_item_text_sec,active&&{color:'#E2231A'}]}>{data.item.nation}</JDText>} */}
                    {/* </View> */}
                </JDTouchable>
            </View>
        );
    }
}

const img = {
    search_clear: require('./img/search_clear.png'),
    search_img: require('./img/search.png'),
    right_img: require('./img/rightImg.png'),
    kw_clear: require('./img/clear.png'),
    lbs: require('./img/lbs.png'),
    lbs_gray: require('./img/lbs_gray.png')
};

CityList.contextTypes = {
    router: PropTypes.object
};
